<template>
  <div class="invoiceManagementSetting">
    <div class="pageTitle">开普通发票</div>
    <div class="titleView">发票信息</div>
    <div class="typeSetting">
      <div class="name_">发票类型</div>
      <div class="type_">
        <div
          class="list"
          v-for="item in pageData.typeList.list"
          :key="item"
          @click="typeSetting(item.type)"
        >
          <img
            :src="
              item.type == pageData.typeList.type
                ? require('@/assets/images/radioIconActive.png')
                : require('@/assets/images/radioIcon.png')
            "
          />
          {{ item.name }}
        </div>
      </div>
    </div>

    <div class="pageContainer">
      <div class="list_">
        <div class="name_">发票抬头</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.invoiceTitle"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="list_">
        <div class="name_">纳税识别号</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.taxIdentificationNumber"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="list_" v-if="pageData.typeList.type == 1">
        <div class="name_">手机号码</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.mobilePhone"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>

      <div class="list_" v-if="pageData.typeList.type == 2">
        <div class="name_">注册地址</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.registeredAddress"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="list_" v-if="pageData.typeList.type == 2">
        <div class="name_">开户银行</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.bank"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="list_" v-if="pageData.typeList.type == 2">
        <div class="name_">开户账号</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.accountNumber"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="list_" v-if="pageData.typeList.type == 2">
        <div class="name_">注册电话</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.registeredTelephone"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>

      <div class="titleView">收票信息</div>
      <div class="list_">
        <div class="name_">电子邮箱</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.email"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="list_">
        <div class="name_">收件人</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.recipient"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="list_">
        <div class="name_">联系电话</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.phone"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="list_">
        <div class="name_">收件地址</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.consigneeAddress"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="titleView">其他信息</div>
      <div class="list_">
        <div class="name_">备注信息</div>
        <div class="input_">
          <el-input
            v-model="pageData.params.remark"
            placeholder="请输入..."
          ></el-input>
        </div>
      </div>
      <div class="button_" @click="invoiceInvoiceFun">申请开票</div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { invoiceInvoice } from "../../api/interfaceList";
import { ElMessage } from "element-plus";
import { useRoute ,useRouter } from "vue-router";
import { reactive, onUnmounted } from "vue";
export default {
  name: "invoiceManagementSetting",
  setup() {
    const route = useRoute();
    const router = useRouter();

    let pageData = reactive({
      params: {
        accountNumber: "",
        bank: "",
        consigneeAddress: "",
        email: "",
        invoiceAmount: "",
        invoiceTitle: "",
        mobilePhone: "",
        orderCodeArr: JSON.parse(Cookies.get("orderCodeArr")) || [],
        phone: "",
        recipient: "",
        registeredAddress: "",
        registeredTelephone: "",
        remark: "",
        taxIdentificationNumber: "",
        userCode: JSON.parse(Cookies.get("userInformation")).userCode,
      },
      typeList: {
        type: route.query.type || 1,
        list: [
          {
            name: "普通发票",
            type: 1,
            imgUrl: import("@/assets/images/radioIconActive.png"),
          },
          {
            name: "增值发票",
            type: 2,
            imgUrl: import("@/assets/images/radioIcon.png"),
          },
        ],
      },
    });
    function invoiceInvoiceFun() {
      let data = pageData.params;
      if (pageData.typeList.type == 1) {
        delete data.registeredAddress;
        delete data.bank;
        delete data.accountNumber;
        delete data.registeredTelephone;
      } else {
        delete data.mobilePhone;
      }
      let type = {
        type: pageData.typeList.type,
      };
      let params = Object.assign(data, type);
      invoiceInvoice(params).then((res) => {
        if (res.code == 1) {
          ElMessage({
            message: res.message,
            type: "success",
          });
          router.go(-1)
        } else {
            ElMessage(res.data[0].message)
        }
      });
    }
    function typeSetting(type) {
      pageData.typeList.type = type;
    }
    onUnmounted(() => {
      Cookies.remove("orderCodeArr");
    });
    return {
      pageData,
      typeSetting,
      invoiceInvoiceFun,
    };
  },
};
</script>
<style lang="scss" scope>
.invoiceManagementSetting {
  width: 1050px;
  padding: 4px 30px 118px 30px;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  .titleView {
    font-size: 16px;
    font-family: AlibabaPuHuiTiM;
    color: #303133;
    margin-top: 16px;
    font-weight: 600;
  }
  .pageContainer {
    .button_ {
      width: 240px;
      height: 40px;
      font-size: 14px;
      font-family: AlibabaPuHuiTiM;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      margin-top: 40px;
      background: #008aea;
      border-radius: 8px;
      cursor: pointer;
    }
    .list_ {
      display: flex;
      align-items: center;
      margin: 20px 0;
      .name_ {
        width: 64px;
        font-size: 12px;
        font-family: AlibabaPuHuiTiR;
        color: #303133;
      }
      .input_ {
        width: 432px;
        // height: 40px;
        // background: #ffffff;
        // border-radius: 6px;
        // border: 1px solid #cccccc;
        // padding: 8px;
        // box-sizing: border-box;
        // input{
        //     width: 100%;
        //     outline: none;
        //     background: none;
        //     border: none;
        // }
      }
    }
  }
  .typeSetting {
    display: flex;
    align-items: center;
    margin: 20px 0;
    .type_ {
      display: flex;
      align-items: center;
      .list {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: AlibabaPuHuiTiM;
        color: #606266;
        margin-right: 20px;
        cursor: pointer;
        img {
          width: 24px;
          margin-right: 2px;
        }
      }
    }
    .name_ {
      width: 64px;
      font-size: 12px;
      font-family: AlibabaPuHuiTiR;
      color: #303133;
    }
  }
  .pageTitle {
    font-size: 14px;
    font-family: AlibabaPuHuiTiM;
    color: #303133;
    line-height: 64px;
    border-bottom: 1px #f7f7f7 solid;
    font-weight: 700;
  }
}
</style>
